module.exports = __webpack_public_path__ + "static/media/CNN.b43844fa.svg";